import React from "react";
import InnerBanner from "../Components/InnerBanner";
import careerBan from "../Assets/Images/careerBan.png";
import { Container } from "react-bootstrap";
export const Privacy = () => {
  var bannerContent = {
    cardTitle: "PRIVACY POLICY",
    cardPara: "",
  };
  return (
    <>
      <InnerBanner bannerCnt={bannerContent} banImg={careerBan} />
      <div className="internal-service-page" id="cyber-essen-certi-service">
        <Container>
          <div className="privacy custom-list sec-padding">
            <h3 className="mb-3">How IG Smart Ltd uses your information</h3>
            This privacy notice tells you what to expect when IG Smart Ltd (IGS)
            collects personal information. It applies to information we collect
            about:
            <ul className="arrow mt-3">
              <li>visitors to our websites;</li>
              <li>
                people who use our on or offline services and/or solutions;
              </li>
              <li>
                people who subscribe to our newsletter or request a publication
                from us;
              </li>
              <li>job applicants and our current and former employees; and</li>
              <li>
                people who attend our events, seminars, work shops and training
                courses
              </li>
            </ul>

            <h3 className="mt-4 mb-3">Visitors to our websites</h3>
            When someone visits 
            <a href="https://www.ig-smart.com/">www.ig-smart.com</a> we use a
            third party service, Google Analytics, to collect standard internet
            log information and details of visitor behaviour patterns. We do
            this to find out things such as the number of visitors to the
            various parts of the site. This information is only processed in a
            way which does not identify anyone. We do not make, and do not allow
            Google to make, any attempt to find out the identities of those
            visiting our website. If we do want to collect personally
            identifiable information through our website, we will be up front
            about this. We will make it clear when we collect personal
            information and will explain what we intend to do with it.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is your consent under article 6(1)(a)
            of the GDPR.
            <h5 className="mt-3 mb-2"><b>Use of cookies by the IGS</b></h5>
            We only use cookies that are required for you to get the best
            experience out of our website, by default. We call these cookies
            functional cookies. You can read more about how we use cookies on
            our 
            <span className="yellow-color">Cookies page</span>.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is your consent under article 6(1)(a)
            of the GDPR.
            <h5 className="mt-3 mb-2"><b>E-newsletter</b></h5>
            We use a third party provider, Mailchimp, to deliver our monthly
            e-newsletters. We gather statistics around email opening and clicks
            using industry standard technologies including clear gifs to help us
            monitor and improve our e-newsletter. For more information, please
            see Mailchimp’s 
            <a href="https://mailchimp.com/legal/privacy/">privacy notice</a>.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is your consent under article 6(1)(a)
            of the GDPR.
            <h5 className="mt-3 mb-2"><b>WordPress</b></h5>
            We use a third party service, WordPress.com to host our sites. These
            sites are hosted at WordPress.com, which is run by Automattic Inc.
            We use a standard WordPress service to collect anonymous information
            about users’ activity on the site, for example the number of users
            viewing pages on the site, to monitor and report on the
            effectiveness of the site and help us improve it. WordPress requires
            visitors that want to post a comment to enter a name and email
            address. For more information about how WordPress processes data,
            please 
            <a href="http://automattic.com/privacy">
              see Automattic’s privacy notice.
            </a>
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is legitimate interest under article
            6(1)(f) of the GDPR.

            <h3 className="mt-4 mb-3">People who contact us via social media</h3>
            We use a third party provider, Hootsuite to manage our social media
            interactions. If you send us a private or direct message via social
            media the message will be stored by Hootsuite for three months. It
            will not be shared with any other organisations.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is legitimate interest under article
            6(1)(f) of the GDPR.
            <h3 className="mt-4 mb-3">People who email us</h3>
            We will also monitor any emails sent to us, including file
            attachments, for viruses or malicious software. Please be aware that
            you have a responsibility to ensure that any email you send is
            within the bounds of the law.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is legitimate interest under article
            6(1)(f) of the GDPR.
            <h3 className="mt-4 mb-3">People who use IGS services</h3>
            IGS offers various services and solutions to businesses and
            organisations. We may use third parties to deal with the delivery of
            some of our services and solutions, but they are only allowed to use
            the information to send out the publications. We have to hold the
            details of the people who have requested the service in order to
            provide it. However, we only use these details to provide the
            service the person has requested and for other closely related
            purposes. For example, we might use information about people who
            have requested a publication to carry out a survey to find out if
            they are happy with the level of service they received.When people
            do subscribe to our services, they can cancel their subscription at
            any time and are given an easy way of doing this
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is necessity for the performance of a
            contract under article 6(1)(f) of the GDPR.
            <h5 className="mt-3 mb-2"><b>Security and performance</b></h5>
            IGS may use third party services to help maintain the security and
            performance of the IGS website. To deliver these services the IP
            addresses of visitors to the IGS website may be processed.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is legitimate interest under article
            6(1)(f) of the GDPR.
            <h3 className="mt-4 mb-3">Job applicants, current and former IGS employees</h3>
            IGS is the data controller for the information you provide during
            the process unless otherwise stated. If you have any queries about
            the process or how we handle your information please contact us at 
            <a href="mailto:info@ig-smart.com">info@ig-smart.com</a>.
            <h6 >What will we do with the information you provide to us?</h6>
            All of the information you provide during the process will only be
            used for the purpose of progressing your application, or to fulfil
            legal or regulatory requirements if necessary. We will not share any
            of the information you provide during the recruitment process with
            any third parties for marketing purposes or store any of your
            information outside of the European Economic Area. The information
            you provide will be held securely by us and/or our data processors
            whether the information is in electronic or physical format. We will
            use the contact details you provide to us to contact you to progress
            your application. We will use the other information you provide to
            assess your suitability for the role you have applied for.
            <p className="p-color">What information do we ask for, and why?</p>
            We do not collect more information than we need to fulfil our stated
            purposes and will not retain it for longer than is necessary. The
            information we ask for is used to assess your suitability for
            employment. You don’t have to provide what we ask for but it might
            affect your application if you don’t.
            <p className="p-color">Application stage</p>
            If you use our online application system, this will be collected by
            a data processor on our behalf (please see below). We ask you for
            your personal details including name and contact details. We will
            also ask you about your previous experience, education, referees and
            for answers to questions relevant to the role you have applied for.
            Our recruitment team will have access to all of this information.
            You will also be asked to provide equal opportunities information.
            This is not mandatory information – if you don’t provide it, it will
            not affect your application. This information will not be made
            available to any staff outside of our recruitment team, including
            hiring managers, in a way which can identify you. Any information
            you do provide, will be used only to produce and monitor equal
            opportunities statistics.
            <p className="p-color">Shortlisting</p>
            Our hiring managers shortlist applications for interview. They will
            not be provided with your name or contact details or with your equal
            opportunities information if you have provided it.
            <p className="p-color">Assessments</p>
            We might ask you to participate in assessment days; complete tests
            or occupational personality profile questionnaires; and/or to attend
            an interview – or a combination of these. Information will be
            generated by you and by us. For example, you might complete a
            written test or we might take interview notes. This information is
            held by IGS. If you are unsuccessful following assessment for the
            position you have applied for, we may ask if you would like your
            details to be retained in our talent pool for a period of six
            months. If you say yes, we would proactively contact you should any
            further suitable vacancies arise.
            <p className="p-color">Conditional offer</p>
            If we make a conditional offer of employment we will ask you for
            information so that we can carry out pre-employment checks. You must
            successfully complete pre-employment checks to progress to a final
            offer. We are required to confirm the identity of our staff, their
            right to work in the United Kingdom and seek assurance as to their
            trustworthiness, integrity and reliability. You will therefore be
            required to provide:
            <ul className="arrow mt-4 mb-3">
              <li>
                Proof of your identity – you will be asked to attend our office
                with original documents, we will take copies.
              </li>
              <li>
                Proof of your qualifications – you will be asked to attend our
                office with original documents, we will take copies.
              </li>
              <li>
                You will be asked to complete a criminal records declaration to
                declare any unspent convictions.
              </li>
              <li>
                We will provide your email address to the Government Recruitment
                Service who will contact you to complete an application for a
                Basic Criminal Record check via the Disclosure and Barring
                Service, or Access NI, which will verify your declaration of
                unspent convictions.
              </li>
              <li>
                We will contact your referees, using the details you provide in
                your application, directly to obtain references
              </li>
              <li>
                We will also ask you to complete a questionnaire about your
                health. This is to establish your fitness to work. This is done
                through a data processor (please see below).
              </li>
            </ul>
            If we make a final offer, we will also ask you for the following:
            <ul className="arrow mt-3">
              <li>Bank details – to process salary payments</li>
              <li>
                Emergency contact details – so we know who to contact in case
                you have an emergency at work
              </li>
            </ul>
            <p className="p-color mt-2"><b>Post start date</b></p>
            Some roles require a higher level of security clearance – this will
            be clear on the advert. If this is the case, then you will be asked
            to submit information via the National Security Vetting process to
            HMRC. HMRC will be the data controller for this information. HMRC
            will tell us whether your application is successful or not. If it is
            unsuccessful, IGS will not be told the reason(s) why but we might
            need to review your suitability for the role or how you perform your
            duties. Our Code of Conduct requires all staff to declare if they
            have any potential conflicts of interest, or if they are active
            within a political party. If you complete a declaration, the
            information will be held on your personnel file.
            <p className="p-color">Use of data processors</p>
            Data processors are third parties who provide elements of our
            recruitment service for us. We have contracts in place with our data
            processors. This means that they cannot do anything with your
            personal information unless we have instructed them to do it. They
            will not share your personal information with any organisation apart
            from us. They will hold it securely and retain it for the period we
            instruct.
            <p className="p-color">How long is the information retained for?</p>
            If you are successful, the information you provide during the
            application process will be retained by us as part of your employee
            file for the duration of your employment plus 6 years following the
            end of your employment. This includes your criminal records
            declaration, fitness to work, records of any security checks and
            references. If you are unsuccessful at any stage of the process, the
            information you have provided until that point will be retained for
            6 months from the closure of the campaign. Information generated
            throughout the assessment process, for example interview notes, is
            retained by us for 6 months following the closure of the campaign.
            Equal opportunities information is retained for 6 months following
            the closure of the campaign whether you are successful or not.
            Vacancy Filler will provide us with management information about our
            recruitment campaigns. This is anonymised information which tells us
            about the effectiveness of campaigns, for example, from which source
            did we get the most candidates, equal opportunities information for
            monitoring purposes. This anonymised information will be retained
            for 6 years from the end of the campaign.
            <p className="p-color">How we make decisions about recruitment?</p>
            Final recruitment decisions are made by hiring managers and members
            of our recruitment team. All of the information gathered during the
            application process is taken into account. You are able to ask about
            decisions made about your application by speaking to your contact
            within our recruitment team or by emailing 
            <a href="mailto:info@ig-smart.com">info@ig-smart.com</a>.
            <strong>Legal basis: </strong>The legal basis we rely on for
            processing your personal data is legitimate interest under article
            6(1)(f) of the GDPR.
            <h3 className="mt-4 mb-3">People who attend an event, seminar, work shop or course</h3>
            We will use your personal information to provide you with
            information about the event, seminar etc., that you will be
            attending. We may also share your information with third parties,
            such as event coordinators and caterers, venue hosts.
            <h3 className="mt-4 mb-3">Your rights</h3>
            Under the Data Protection Act 2018 Act and General Data Protection
            Regulation, you have rights as an individual which you can exercise
            in relation to the information we hold about you. You can read more
            about these rights here – 
            <a href="https://ico.org.uk/for-the-public/is-my-information-being-handled-correctly/">
              https://ico.org.uk/for-the-public/is-my-information-being-handled-correctly/
            </a>
            <h3 className="mt-4 mb-3">Complaints or queries</h3>
            IGS tries to meet the highest standards when collecting and using
            personal information. For this reason, we take any complaints we
            receive about this very seriously. We encourage people to bring it
            to our attention if they think that our collection or use of
            information is unfair, misleading or inappropriate. We would also
            welcome any suggestions for improving our procedures. This privacy
            notice was drafted with brevity and clarity in mind. It does not
            provide exhaustive detail of all aspects of IGS’s collection and use
            of personal information. However, we are happy to provide any
            additional information or explanation needed. Any requests for this
            should be sent to the address below. If you want to make a complaint
            about the way we have processed your personal information, you can
            contact us:
            <div>20-22 Wenlock Road, London, N1 7TA</div>
            <div>+44 (0) 20 382 42426</div>
            <div>
              <a href="mailto:info@ig-smart.com">info@ig-smart.com</a>
            </div>
            <div></div>
            <div></div>
            <div>
              You have a right to complain to the Information Commissioners
              Office if you are in any way dissatisfied with the way that IG
              Smart Ltd has handled your data. We are committed to cooperating
              with the ICO and respect the work that they do. You can report any
              concerns via their 
              <a href="https://ico.org.uk/concerns/">online portal </a>or
              call their helpline on 0303 123 1113
            </div>
            <div></div>
            &nbsp;
            <h3 className="mt-4 mb-3">Access to personal information</h3>
            IGS tries to be as open as it can be in terms of giving people
            access to their personal information. Individuals can find out if we
            hold any personal information by making a ‘subject access request’
            under the Data Protection Act. If we do hold information about you
            we will:
            <ul className="arrow mt-3">
              <li>give you a description of it;</li>
              <li>tell you why we are holding it;</li>
              <li>tell you who it could be disclosed to; and</li>
              <li>
                let you have a copy of the information in an intelligible form.
              </li>
            </ul>
            To make a request to IGS for any personal information we may hold
            you need to put the request in writing addressing it to our
            Information Governance department, or writing to the address
            provided below. If you agree, we will try to deal with your request
            informally, for example by providing you with the specific
            information you need over the telephone. If we do hold information
            about you, you can ask us to correct any mistakes by, once again,
            contacting the Information Governance department.
            <h3 className="mt-4 mb-3">Disclosure of personal information</h3>
            In many circumstances we will not disclose personal data without
            consent. However, when we investigate a complaint, for example, we
            will need to share personal information with the organisation
            concerned and with other relevant bodies. You can also get further
            information on:
            <ul className="arrow mt-3">
              <li>
                agreements we have with other organisations for sharing
                information;
              </li>
              <li>
                circumstances where we can pass on personal data without consent
                for example, to prevent and detect crime and to produce
                anonymised statistics;
              </li>
              <li>
                our instructions to staff on how to collect, use and delete
                personal data; and
              </li>
              <li>
                how we check that the information we hold is accurate and up to
                date.
              </li>
            </ul>
            <h3 className="mt-4 mb-3">Links to other websites</h3>
            This privacy notice does not cover the links within this site
            linking to other websites. We encourage you to read the privacy
            statements on the other websites you visit.
            <h3 className="mt-4 mb-3">Changes to this privacy notice</h3>
            We keep our privacy notice under regular review. This privacy notice
            was last updated on 23 Sep 2019.
            <h3 className="mt-4 mb-3">How to contact us</h3>
            If you want to request information about our privacy policy you can 
            <a href="mailto:info@ig-smart.com">email</a> us or call 020 3 824
            2426
          </div>
        </Container>
      </div>
    </>
  );
};
